<div fxLayout="row" fxLayoutAlign="start center">
  <div *ngIf="(hasLoadError$ | async) === true" class="spinner-container">
    <span color="warn">{{ "MERCHANT.ERROR.GET" | translate }}</span>
  </div>
</div>

<app-merchant-basic-data-form
  *ngIf="isLoaded$ | async"
  [basicData]="data$ | async"
  [isLoading]="false"
  [logoUrl]="logoUrl$ | async"
  [isLogoUpdating]="(isLogoUpdating$ | async) ?? false"
  [updating]="(isUpdating$ | async) ?? false"
  [error]="updateError$ | async"
  (submitData)="onSubmit($event)"
  (cancel)="onLoad()"
></app-merchant-basic-data-form>
